import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "@/api/client";
import { notificationsKey } from "@/notifications/api";

/* /api/portal/* — only the fields a client may see (no costs, rates or internal notes). */
export interface PortalTicket {
  id: string;
  number: string;
  title: string;
  type: string | null;
  priority: string;
  status: string;
  bau_solution: string | null;
  requested_by: string | null;
  assigned_to: string | null;
  requested_at: string;
  last_status_change_at: string | null;
  completed_at: string | null;
}

export interface PortalSolution {
  id: string;
  name: string;
  department: string | null;
}

export type TicketState = "open" | "closed" | "all";

const keys = {
  tickets: (state: TicketState) => ["portal", "tickets", state] as const,
};

export const usePortalTickets = (state: TicketState) =>
  useQuery({ queryKey: keys.tickets(state), queryFn: () => apiFetch<PortalTicket[]>("/portal/tickets", { query: { state } }) });

export const usePortalSolutions = () =>
  useQuery({ queryKey: ["portal", "bau-solutions"], queryFn: () => apiFetch<PortalSolution[]>("/portal/bau-solutions") });

export interface NewTicket {
  title: string;
  detailed_requirement: string;
  bau_solution_id: string;
  priority: string;
}

export function useRaiseTicket() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: NewTicket) => apiFetch<PortalTicket>("/portal/tickets", { method: "POST", body }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["portal", "tickets"] });
      void qc.invalidateQueries({ queryKey: notificationsKey });
    },
  });
}
